import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { filter, mergeMap, withLatestFrom } from 'rxjs/operators';
import * as presets from '@webapp/sdk/artist-presets';
import { Actions } from '../../actions';
import {
  UpdateArtistPresets,
  UpdateArtistPresetsError,
  UpdateArtistPresetsSuccess,
} from '../action-creators';
import { UPDATE_ARTIST_PRESETS } from '../actions';
import AppState from '../../state';
import { releasePresetsUpdatedEvent } from '@webapp/utils/rudderstack/events';
import { SINGLE_PRICES } from '@common/types/artist-preset/catalog-tier';

export const updatePresetsEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, UpdateArtistPresets>(UPDATE_ARTIST_PRESETS),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.artist.active?.id),
    mergeMap(async ([action, state]) => {
      try {
        const artistPresets = await presets.update(
          state.artist.active?.id as string,
          action.presets
        );

        if (state.artist.active?.id) {
          await releasePresetsUpdatedEvent({
            artist_id: state.artist.active.id,
            artist_name: state.artist.active.name,
            copyright: artistPresets.copyright,
            price_per_single: artistPresets.pricePerSingle
              ? SINGLE_PRICES[artistPresets.pricePerSingle]
              : '',
            release_time: [
              {
                hour: artistPresets?.releaseTime?.hour,
                minute: artistPresets?.releaseTime?.minutes,
                period: artistPresets?.releaseTime?.period,
              },
            ],
            label_name: artistPresets.recordLabel,
            genres:
              artistPresets?.genres?.map((genre, index) => ({
                name: genre.value,
                is_primary: index === 0,
              })) || [],
            language: artistPresets.language
              ? artistPresets.language
              : action.presets?.language,
          });
        }

        return new UpdateArtistPresetsSuccess(artistPresets);
      } catch (err) {
        return new UpdateArtistPresetsError(err.message);
      }
    })
  );
